import tileset from "./tileset.jsx";
import tiles from "./tiles.jsx";
export default {
  tiles,
  tileset,
};
